import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const isAuthenticated =
    localStorage.getItem("sessionToken") ?? sessionStorage.getItem("sessionToken");

  return isAuthenticated ? (
    <Navigate to="/main/pdf-text-replacer" replace />
  ) : (
    children || <Outlet />
  );
};

export default AuthRoute;
